import AbstractController from './AbstractController';
import ProductFilter from "@/components/ProductFilter";

export default class ProductList extends AbstractController {
    constructor() {
        super();
        new ProductFilter();

        this.initSeoTextSpoiler();
    }

    initSeoTextSpoiler() {
        const el = document.querySelector('.product-list-seo-text');

        if (!el) {
            return;
        }

        if (window.matchMedia("(max-width: 768px)").matches === false) {
            return;
        }

        if (el.clientHeight - 150 < 20) {
            return;
        }

        el.classList.add('product-list-seo-text--collapsed');

        const fragment = document.createRange().createContextualFragment('<div class="product-list-seo-text-spoiler"><span class="product-list-seo-text-spoiler__trigger">Подробнее</span></div>');

        el.after(fragment);

        document.querySelector('.product-list-seo-text-spoiler__trigger').addEventListener('click', (e) => {
            el.classList.remove('product-list-seo-text--collapsed');
            e.target.remove();
        });
    }
}
